import axios from "axios";
import Cookies from "js-cookie";

//  export const MAIN_URL = "http://localhost:8000";
// export const MAIN_URL = "https://easytracknow.com";

// export const MAIN_URL = "https://kuponger.fabconcept.no";
 export const MAIN_URL = "https://dev-coupon.digifront.biz";

export const getDeletedUserAccountsByCompany = async (companyId, page = 1, perPage = 10) => {
    try {
        // Use axios instance instead of fetch to ensure cookies and Authorization header are sent
        const response = await api.get(`/companies/${companyId}/deleted-users`, {
            params: { page, per_page: perPage }
        });
        // Return response.data to match the old fetch structure (which returned JSON directly)
        // This maintains compatibility with existing code that expects { status: true, data: {...} }
        return response.data;
    } catch (error) {
        console.error('Error fetching deleted user accounts:', error);
        throw error;
    }
};

export const deleteUserAccount = async (userId, companyId, confirmation) => {
    try {
        // Use axios instance instead of fetch to ensure cookies and Authorization header are sent
        const response = await api.post('/delete-user-account', {
            user_id: userId,
            company_id: companyId,
            confirmation: confirmation
        });
        // Return response.data to match the old fetch structure
        return response.data;
    } catch (error) {
        console.error('Error deleting user account:', error);
        throw error;
    }
};

export const getCompanyValueBankStats = async (companyId) => {
    try {
        // Use axios instance instead of fetch to ensure cookies and Authorization header are sent
        const response = await api.get(`/company/${companyId}/valuebank-stats`);
        // Return response.data to match the old fetch structure
        return response.data;
    } catch (error) {
        console.error('Error fetching company value bank stats:', error);
        throw error;
    }
};


const API_BASE_URL = `${MAIN_URL}/api`;


const USERS_API_URL = `${API_BASE_URL}/users`; // Users API endpoint

//const ADMIN_LOGIN_URL = `${API_BASE_URL}/verify-admin-login`;

export const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        "Content-Type": "application/json",
    },
    withCredentials: true, // This ensures cookies are sent with requests
});

// Add request interceptor to include session token in Authorization header as fallback
api.interceptors.request.use(
    (config) => {
        // Try to get session token from cookie (for cases where cookie doesn't work)
        const sessionToken = Cookies.get("admin_session_token");
        if (sessionToken) {
            config.headers.Authorization = `Bearer ${sessionToken}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);



export const getCoupons = () => {
    return api.get('/coupons');
};

export const userGetCoupons = (id) => {
    return api.get(`/getcoupons/${id}`);
};

export const userCoupons = (id, company_id) => {
    return api.get(`/getusercoupons/${id}`, {
        params: { company_id ,id},
    });
};

export const verifyAdminLogin = (userIdentifier) => {
    return api.post('/verify-admin-login', {
        user: userIdentifier,
    });
};

export const verifyUserMobileLogin = (userIdentifier) => {
    return api.post('/verify-mobile-login', {
        user: userIdentifier,
    });
};

export const fetchUserPost = () => {
    return api.get('/users');
};

export const userDetails = (id) => {
    return api.get(`/users/${id}`);
};

export const campaignsDetails = () => {
    return api.get('/all-campaigns');
};

export const checkCampaignCode = (code) => {
    return api.post('/check-campaign-code', {
        campaign_code: code,
    });
};

export const createCouponLog = (data) => {
    return api.post('/create-coupon-log', data);
};

export const logUserLogin = (data) => {
    return api.post('/user-login-log', data);
};

export const firstTimeLogin = (user) => {
    return api.post('/first-time-login', user);
};

export const storeUserAcceptance = (user) => {
    return api.post('/check-first-time-accept', user);
};

// coupon used by user
export const applyCoupon = (couponId, userId = null) => {
    const user_id = userId || Cookies.get("user_id");
    return api.post(`/coupons/${couponId}/use`, {
        user_id: user_id
    });
};

export const getCouponsListByCompany = (id, page = 1, perPage = 10) => {
    return api.get(`/companies/${id}/coupons`, {
        params: { page, per_page: perPage }
    });
};

export const getUsedCouponsListByCompany = (id, page = 1, perPage = 10) => {
    return api.get(`/companies/${id}/used-coupons`, {
        params: { page, per_page: perPage }
    });
};

export const getDeletedCouponsListByCompany = (id, page = 1, perPage = 10) => {
    return api.get(`/companies/${id}/deleted-coupons`, {
        params: { page, per_page: perPage }
    });
};

// Campaign API functions
const buildCampaignFormData = (campaignData = {}) => {
    const formData = new FormData();

    Object.entries(campaignData).forEach(([key, value]) => {
        if (value === undefined || value === null || value === "") {
            return;
        }

        if (key === "coupons" && Array.isArray(value)) {
            value.forEach((couponId) => formData.append("coupons[]", couponId));
            return;
        }

        if (typeof value === "boolean") {
            formData.append(key, value ? "1" : "0");
            return;
        }

        formData.append(key, value);
    });

    return formData;
};

export const createCampaign = (campaignData) => {
    const formData = buildCampaignFormData(campaignData);
    return api.post('/campaigns', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export const updateCampaign = (id, campaignData) => {
    const formData = buildCampaignFormData(campaignData);
    return api.post(`/campaigns/${id}?_method=PUT`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export const deleteCampaign = (id) => {
    return api.delete(`/campaigns/${id}`);
};

export const generateCampaignQR = (id) => {
    return api.get(`/campaigns/${id}/qr`);
};

export const getCampaignById = (id) => {
    return api.get(`/campaigns/${id}`);
};

// Coupon API functions
export const createCoupon = (couponData) => {
    return api.post('/coupons', couponData);
};

export const updateCoupon = (id, couponData) => {
    return api.put(`/coupons/${id}`, couponData);
};

export const deleteCoupon = (id) => {
    return api.delete(`/coupons/${id}`);
};

export const getCouponById = (id) => {
    return api.get(`/coupons/${id}`);
};

// User API functions
export const createUser = (userData) => {
    return api.post('/users', userData);
};

export const updateUser = (id, userData) => {
    return api.put(`/users/${id}`, userData);
};

export const deleteUser = (id) => {
    return api.delete(`/users/${id}`);
};

// Company API functions
export const createCompany = (companyData) => {
    return api.post('/companies', companyData);
};

export const updateCompany = (id, companyData) => {
    return api.put(`/companies/${id}`, companyData);
};

export const deleteCompany = (id) => {
    return api.delete(`/companies/${id}`);
};

export const getCompanyById = (id) => {
    return api.get(`/companies/${id}`);
};

// Admin API functions
export const getAdminCompanyId = (adminId) => {
    return api.get(`/admin-company-id/${adminId}`);
};

export const getUserCampaigns = (mobile, adminCompanyId) => {
    return api.get(`/user-campaigns/${mobile}`, {
        params: { admin_company_id: adminCompanyId }
    });
};

export const updateUserToggle = (mobileNumber, field, value) => {
    return api.post('/admin/user-toggle', {
        mobile_number: mobileNumber,
        field: field,
        value: value,
    });
};

export const searchUsers = (query, adminCompanyId) => {
    return api.post('/admin/search-users', {
        query: query,
        admin_company_id: adminCompanyId
    });
};

export const getUserByMobile = (mobile, companyId) => {
    return api.get(`/user-by-mobile/${mobile}`, {
        params: { admin_company_id: companyId }
    });
};

export const getAdminCouponsByMobile = (mobile, companyId) => {
    return api.get(`/getadmincoupons/${mobile}`, {
        params: { company_id: companyId , mobile_number: mobile}
    });
};

export const getValuebankByMobile = (mobile, adminCompanyId) => {
    return api.get(`/getValuebank/${mobile}`, {
        params: { admin_company_id: adminCompanyId }
    });
};

export const getCouponlogByMobile = (mobile, adminCompanyId) => {
    return api.get(`/getCouponlog/${mobile}`, {
        params: { admin_company_id: adminCompanyId }
    });
};

export const getUserCampaignsByMobile = (mobile, adminCompanyId) => {
    return api.get(`/user/${mobile}/campaigns`, {
        params: { admin_company_id: adminCompanyId }
    });
};

export const updateUserByMobile = (mobile, userData) => {
    return api.put(`/user-by-mobile/${mobile}`, userData);
};

export const createIndividualCoupons = (couponData) => {
    return api.post('/admin/individual-coupons', couponData);
};

export const createUserWithCoupons = (userAndCouponData) => {
    return api.post('/admin/create-user-with-coupons', userAndCouponData);
};

export const updateCouponExpiry = (couponId, expiryDate) => {
    return api.post('/admin/update-coupon-expiry', {
        coupon_id: couponId,
        expiry_date: expiryDate
    });
};

// Value Bank API functions
export const userUsedPoints = (id) => {
    return api.post(`/user-used-points/${id}`);
};

export const adminAddedPoints = (data) => {
    return api.post(`/admin/added-points`, data);
};

export const adminUsedPoints = (data) => {
    return api.post(`/admin/used-points`, data);
};

export const updateValueBankComment = (id, comment) => {
    return api.post(`/value-bank/${id}/comment`, { comment });
};

// User Registration API functions
export const createUserCampaign = (campaignData) => {
    return api.post('/user-campaign', campaignData);
};

export const redeemPoints = (pointsData) => {
    return api.post('/use-points', pointsData);
};

// Campaign check API function
export const checkCampaignJoined = (campaignData) => {
    return api.post('/check-campaign-joined', campaignData);
};

// Remove user from campaign API function
export const removeUserFromCampaign = (campaignData) => {
    return api.post('/remove-user-campaign', campaignData);
};


export const markCouponOpened = (couponId) => {
    return api.post(`/coupons/${couponId}/mark-opened`);
};

// Admin logout API function
export const adminLogout = () => {
    return api.post('/admin/logout');
};

// Admin session validation API function
export const validateAdminSession = () => {
    return api.get('/admin/validate-session');
};

// Admin login history API function
export const getAdminLoginHistory = (params = {}) => {
    return api.get('/admin/login-history', { params });
};

// Active admin sessions API function
export const getActiveAdminSessions = () => {
    return api.get('/admin/active-sessions');
};

// Utility functions
export const uploadFile = (file, endpoint = '/upload') => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post(endpoint, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

// export const getCouponsByCompany = (id) => {
//     return axios.get(`${API_BASE_URL}/company-coupons/${id}`);
// };

// Coupon Initial (Template) API functions
const buildCouponInitialFormData = (couponData) => {
    const formData = new FormData();
    formData.append('name', couponData.name);
    if (couponData.description !== undefined) formData.append('description', couponData.description);
    if (couponData.offer_text) formData.append('offer_text', couponData.offer_text);
    if (couponData.coupon_image) formData.append('coupon_image', couponData.coupon_image);
    if (couponData.offer_image) formData.append('offer_image', couponData.offer_image);
    if (couponData.valid_days !== undefined) formData.append('valid_days', couponData.valid_days);
    if (couponData.open_date) formData.append('open_date', couponData.open_date);
    if (couponData.usable_date) formData.append('usable_date', couponData.usable_date);
    return formData;
};

export const createCouponInitial = (couponData) => {
    return api.post('/coupon-initials', buildCouponInitialFormData(couponData), {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export const getCouponInitials = () => {
    return api.get('/coupon-initials');
};

export const updateCouponInitial = (id, couponData) => {
    const formData = buildCouponInitialFormData(couponData);
    return api.post(`/coupon-initials/${id}?_method=PUT`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export const deleteCouponInitial = (id) => {
    return api.delete(`/coupon-initials/${id}`);
};
